var React = require('react');
var PropTypes = React.PropTypes;
import MCQuestionContent from '../QuestionContent/MCQuestion';
import ShortQuestionContent from '../QuestionContent/ShortQuestion';
import LongQuestionContent from '../QuestionContent/LongQuestion';
import PartDescription from '../QuestionContent/LongQuestionFraction/PartDescription';
import Solution from '../QuestionContent/Solution';
import Helpers from '../../utils/helpers'

var ExamContent = React.createClass({
    getInitialState: function() {
        return {
            conceptsMap: this.props.conceptsMap,
            courses: this.props.courses,
        };
    },
    deleteQuestion: function(collection_id, question_id) {
        var _this = this;
        this.props.deleteQuestionCollection(collection_id, question_id);
    },
    triggerEditScores: function(question) {
      if (question.isEdditing === undefined) {
        question.isEdditing = true;
        question.oldNumPoints = question.numPoints;
      } else {
        question.isEdditing = !question.isEdditing;
      }
      
      if (!question.isEdditing) {
        var scores = this.refs["question-" + question._id].value;
        
        if (scores <= 0) {
          question.changeScoresError = true;
        } else {
          question.changeScoresError = false;
          if (scores != question.oldNumPoints) {
            question.isScoresChanged = true;
          } else {
            question.isScoresChanged = false;
          }
        }
        
      }

      this.forceUpdate(function() {
        if (question.isEditting) {
          this.refs["question-" + question._id].focus();
        }
      });
    },
    onScoresChange: function(question, e) {
      var scores = parseFloat(e.target.value || 0.1);
      var collection = this.props.collection;
      var questionIndex = collection.questions.indexOf(question);
      if (scores > 0) {
        collection.questions[questionIndex].numPoints = scores;
      }
      this.props.calculatorDataCollection(collection);
    },
    render: function() {
        var _this = this;
        return (
            <div className="col-md-7 collection-content content-play">
            {
            _this.props.collection.questions.map(function(question, index) {
                if(question.type === _this.props.currentPart || _this.props.collection.status === 'published'){
                return(
                    <div className="question-area" key={"question-area" + index}>
                        <div className="text-desc" key={"text-desc" +index}>
                               <span className="question-index">{index+1}</span>
                                {question.title&&
                                    <span className="title-question"> - {question.title} </span>
                                }
                                {
                                  !question.isEdditing &&
                                  <span className="title-question"> {question.kquestion.title} <span style={question.changeScoresError ? {"color": "red"} : {}}> {question.numPoints} </span> {question.numPoints>1?' Scores':' Score'}</span>
                                }

                                {
                                  question.isEdditing && (_this.props.collection.status === "to_be_reviewed") &&
                                  <span className="title-question">
                                  <input
                                    ref={"question-" + question._id}
                                    type="number"
                                    step="0.1"
                                    min="0.1"
                                    onBlur={_this.triggerEditScores.bind(_this, question)}
                                    onChange={_this.onScoresChange.bind(_this, question)}
                                    value={question.numPoints}
                                    style={{"width": "50px"}}/>
                                    {
                                      question.changeScoresError &&
                                      <p style={{"color": "red"}}> Please enter a valid number </p>
                                    }
                                  </span>
                                }
                                {(_this.props.collection.status === "to_be_reviewed") &&
                                      <span>
                                               <a href="javascript:void(0)" onClick={_this.triggerEditScores.bind(_this, question)}>
                                                      <span className="title-icon">
                                                        <i className="fa fa-pencil-square-o" aria-hidden="true"></i>
                                                      </span>
                                                </a>
                                                <a href="javascript:void(0)" onClick={_this.deleteQuestion.bind(this, _this.props.collection._id, question.questionRef)}>
                                                      <span className="title-icon-red">
                                                        <i className="fa fa-times-circle" aria-hidden="true"></i>
                                                      </span>
                                                    </a>
                                      </span>
                                  }
                               
                        </div>

                        <div className="content-title">
                          <span dangerouslySetInnerHTML={{__html: Helpers.convertToHtml(question.kquestion.description) || 'No title'}}></span>
                          {
                            question.kquestion.image && <img src={question.kquestion.image} style={{"maxWidth": "100%", "display": "block", "margin": "10px auto"}}/>
                          }
                        </div>

                        {question.kquestion.type === 22 &&
                           <div className="long-question">
                               <div className="long-question-parts">
                                  <div className="text-input-wrapper">
                                    <div className="parts-list">
                                      {
                                        question.kquestion.textInputAnswers.map(function(textInput, index) {
                                          return (
                                            <div key={index} className="part">
                                              <PartDescription
                                                content={textInput}
                                                contentIndex={index}
                                                numPoints={question.numPoints}
                                                score={question.kquestion.score}
                                                />
                                              {
                                                question.kquestion.solution[index] && question.kquestion.solution[index].subItems && question.kquestion.solution[index].subItems.length > 0 &&
                                                <Solution solution={question.kquestion.solution[index].subItems} />
                                              }
                                            </div>
                                          )
                                        })
                                      }
                                    </div>
                                  </div>
                                </div>
                            </div>
                        }
                        {question.kquestion.type === 11 &&
                             <div className="choice-wrapper">
                                  <ul className="choice-list">
                                    {
                                      question.kquestion.selectionChoices.map(function(choice, index) {
                                        return (
                                          <li className="choice" key={index}>
                                            <input type="checkbox" id={"question-" + question.questionIndex + "-choice-" + index}/>
                                            <label className={choice.answerValue > 0 ? "is-right" : ""} htmlFor={"question-" + question.questionIndex + "-choice-" + index}>
                                              {
                                                choice.image && <img alt="Choice" src={choice.image}/>
                                              }
                                              {
                                                choice.text ? (<p dangerouslySetInnerHTML={{__html: choice.text}}></p>) : (<p>No text</p>)
                                              }
                                            </label>
                                          </li>
                                        )
                                      })
                                    }
                                  </ul>
                                </div>

                        }
                        {question.kquestion.type === 21 &&
                            <div className="margin-bottom-15">
                                {
                                       <div className="text-input-wrapper">
                                          <ul className="text-input-list">
                                            <li>
                                              <h4>Answer</h4>
                                            </li>  
                                            <li>
                                              {
                                                (question.kquestion.textInputAnswers[0].preText &&
                                                  <div className="cell">
                                                    <input className="form-control" disabled type="text" defaultValue={question.kquestion.textInputAnswers[0].preText}/>
                                                  </div>
                                                )
                                              }
                                              {
                                                (question.kquestion.textInputAnswers[0].text &&
                                                  <div className="cell" style={{'minWidth': "50%"}}>
                                                    {/* <input className="form-control" disabled type="text" defaultValue={question.kquestion.textInputAnswers[0].text}/> */}
                                                     <span dangerouslySetInnerHTML={{__html: Helpers.convertToHtml(question.kquestion.textInputAnswers[0].text)}}></span>
                                                  </div>
                                                )
                                              }
                                              {
                                                (question.kquestion.textInputAnswers[0].postText &&
                                                  <div className="cell">
                                                    <input className="form-control" disabled type="text" defaultValue={question.kquestion.textInputAnswers[0].postText}/>
                                                  </div>
                                                )
                                              }
                                            </li>
                                          </ul>
                                        </div>
                                }
                            </div>
                        }
                        {question.kquestion.type !== 22 &&question.kquestion.solution.length>0&&
                              <Solution solution={question.kquestion.solution} />
                        }

                    </div>
                )
              }
                })
            }
      </div>
        )
    }
})

export default ExamContent;



/** WEBPACK FOOTER **
 ** ./src/components/ExamEditor/ExamContent.js
 **/